import TrashContent from "../Trash/TrashContent";
import { ConfigurationPageType } from "../interfaces";

// CUSTOM rather than TABLE: the status chip, the days-remaining countdown, the
// restore action and the polling are not expressible through
// ConfigurationTableModel, and forcing them in would mean extending the shared
// table config for a single consumer.
export const SETUP_TRASH_PAGE = {
  type: ConfigurationPageType.CUSTOM as const,
  component: TrashContent,
  menuLabel: "TRASH",
  label: "TRASH",
  path: "trash",
  description: "CONF_DESC_SETUP_TRASH",
  // Restoring is destructive in its own right: it can collide with data a
  // connector recreated during probation. Open it up once the round trip has
  // been validated in production.
  isStaff: true,
};
